/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Dialog,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Status_Type } from "../../types";
import AxiosInstance from "../../API/axios";

interface EditLessonProps {
  isOpen: boolean;
  onClose: () => void;
  handleEditLesson: (formData: any) => void;
  lesson: any;
  data: any;
}

const EditLessonModal: React.FC<EditLessonProps> = ({
  isOpen,
  onClose,
  lesson,
  data,
  handleEditLesson,
}) => {
  const [editedValues, setEditedValues] = useState<any>({});
  const [lesType, setLesType] = useState<Status_Type[]>([]);
  const [formData, setFormData] = useState<any>({
    id: "",
    title: "",
    duration: "",
    video_type: "",
    video_url: "",
    lesson_type: "",
    attachment_url: "",
    attachment_type: "",
  });

  const fetchLessonType = async () => {
    try {
      const response = await AxiosInstance.get("/admin/courses/v1/lesson-type");
      setLesType(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    setEditedValues(lesson);
    setFormData({
      id: lesson.lesson_id,
      title: lesson.title,
      duration: lesson.duration,
      video_type: lesson.video_type,
      video_url: lesson.video_url,
      lesson_type: lesson.lesson_type,
      attachment_url: lesson.attachment_url,
      attachment_type: lesson.attachment_type,
    });
    fetchLessonType();
  }, [lesson]);

  const handleInputChange = (key: string, value: any) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleSave = () => {
    handleEditLesson(formData);
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div className="fixed w-full max-w-screen-md p-4 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg top-1/2 left-1/2 md:w-1/2 md:p-8">
        <h2 className="px-4 py-2 text-lg font-semibold md:text-xl bg-primary_shade text-blue">
          Edit lesson
        </h2>

        <div className="w-full mt-4">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Lesson Title"
                value={formData.title || ""}
                onChange={(e) => handleInputChange("title", e.target.value)}
                fullWidth
                margin="dense"
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Duration"
                value={formData.duration || ""}
                onChange={(e) => handleInputChange("duration", e.target.value)}
                fullWidth
                margin="dense"
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Video Type"
                value={formData.video_type || ""}
                onChange={(e) =>
                  handleInputChange("video_type", e.target.value)
                }
                fullWidth
                margin="dense"
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Video URL"
                value={formData.video_url || ""}
                onChange={(e) => handleInputChange("video_url", e.target.value)}
                fullWidth
                margin="dense"
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl
                fullWidth
                variant="outlined"
                margin="dense"
                size="small"
              >
                <InputLabel>Lesson type</InputLabel>
                <Select
                  value={formData.lesson_type || ""}
                  label="Lesson type"
                  onChange={(e) =>
                    handleInputChange("lesson_type", e.target.value)
                  }
                  // onChange={(e) =>
                  //   setLessonLessonType(e.target.value as string)
                  // }
                >
                  {lesType.map((type) => (
                    <MenuItem value={type.Status_Name}>
                      {type.Status_Name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Attachment URL"
                value={formData.attachment_url || ""}
                onChange={(e) =>
                  handleInputChange("attachment_url", e.target.value)
                }
                fullWidth
                margin="dense"
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Attachment Type"
                value={formData.attachment_type || ""}
                onChange={(e) =>
                  handleInputChange("attachment_type", e.target.value)
                }
                fullWidth
                margin="dense"
                size="small"
              />
            </Grid>
          </Grid>
        </div>

        <div className="flex items-center justify-between w-full mt-10">
          <button
            type="button"
            className="px-4 py-2 border rounded-md border-primary text-primary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="px-4 py-2 text-white rounded-md bg-primary"
            onClick={handleSave}
          >
            Save changes
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default EditLessonModal;
